import Icon from '../../components/Icon.vue'

Icon.register({"brands/opera":{"width":496,"height":512,"paths":[{"d":"M313.9 32.7C143.7 32.7 61.3 256.5 166.4 387.8 202.9 433.2 255 463.4 313.9 463.4 350.2 463.4 384.2 452.3 413.3 433 369.5 472.2 311.4 496 248 496 244.1 496 240 496 236.1 495.7 104.6 489.6 0 381.1 0 248 0 111 111 0 248 0H248.8C311.9 0.3 369.5 24.1 413.2 63.1 384.2 43.7 350.1 32.7 313.9 32.7zM415.7 430.4C374.8 455.1 325 454 283.7 424.6 339.9 404.1 381.4 333 381.4 248 381.4 163.3 340.2 92.2 284 71.4 325.8 42.2 375.2 41.1 416.9 66.4 522.8 165.1 522.4 332.1 415.7 430.4z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/opera.js
// module id = null
// module chunks = 